<template>
	<div class="match_left">
		<div class="match_menu">
			<div class="match_button" @click="menuActive = true">
				<span></span>
				<i data-v-9b8449ee="" class="ico icon-side-arrow"></i>
			</div>
			
			<div class="match_menu-inner" :class="{ active: menuActive }">
				<div class="header_menu-top match_menu-top">
					<div class="header_menu-close" @click="menuActive = false"></div>
				</div>
				<router-link :to="{ name: 'tournament', params: {id: item.id} }" class="match_menu-item" v-for="item in items" :key="item.id">
					<img :src="$hostname + item.image_ref" alt="">
					<span>{{ item.name }}</span>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
	import moment from 'moment'
	
	export default {
		props: ['type'],
		
		data() {
			return {
				items: [],
				menuActive: false
			}
		},
		
		created() {
			let url = '/api/tournaments';
			
			if (this.type) {
				url += '?sport=' + this.type;
			}
			
			this.axios.get(url)
				.then(({data}) => {
					this.items = data;
					
					this.initTitle();
				});
		},
		methods: {
			initTitle() {
				setTimeout(() => {
					var text = $('.match_menu-item.router-link-active span').text();
					var img = $('<img />').attr('src', $('.match_menu-item.router-link-active img').attr('src'));
					
					if (text.length) {
						$('.match_button span').html('').append(img).append(text);
					} else {
						$('.match_button span').html('Лиги');
					}
				}, 200);
			},
		},
	}
</script>

<style scoped>

</style>